module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "errPage-container"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('h1', {
    staticClass: "text-jumbo text-ginormous"
  }, [_vm._v("Oops!")]), _vm._v(" "), _c('h2', [_vm._v("你没有权限")]), _vm._v(" "), _c('h6', [_vm._v("如有不满请联系你领导")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', [_vm._v("或者你可以其他账号登录:")]), _vm._v(" "), _c('li', {
    staticClass: "link-type"
  }, [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("去登录")])], 1), _vm._v(" "), _c('li', {
    staticClass: "link-type"
  }, [_c('a', {
    attrs: {
      "href": "https://home.yxcg.net/#/"
    }
  }, [_vm._v("返回小森林管理平台")])])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/401.gif"),
      "width": "313",
      "height": "428",
      "alt": "Girl has dropped her ice cream."
    }
  })])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "随便看",
      "visible": _vm.dialogVisible,
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    staticClass: "pan-img",
    attrs: {
      "src": _vm.ewizardClap
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-149830c6"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/views/401.vue
// module id = 555
// module chunks = 0